export enum ComplexityType {
    Easy = 1,
    Average = 2,
    Hard = 3
}
